import Navigation from "@client/components/site-header/components/journey-navigation";
import Logo from "@client/components/site-header/components/logo";
import clsx from "clsx";

interface Props {
	baseUrl?: string;
	children?: React.ReactNode;
	logo?: string;
	stepOne?: string;
	trustPilotWidget?: boolean;
	variant?: string;
}

export default function SiteHeader({
	baseUrl,
	children,
	logo,
	stepOne,
	trustPilotWidget,
	variant,
}: Props) {
	return (
		<header
			// Note: If you pass `className="site-header--is-${variant}"` it won't get picked up by tailwind.
			className={clsx({
				"site-header": true,
				"site-header--is-alternate": variant === "dark",
				"site-header--is-default": variant === "light",
			})}
			id="site-header"
		>
			<div
				className={clsx({
					"site-header__container": true,
					"gap-x-0": trustPilotWidget === true,
				})}
			>
				{children || (
					<>
						<Logo baseUrl={baseUrl} logo={logo} />
						<Navigation ctaUrl={stepOne} />
					</>
				)}
			</div>
		</header>
	);
}
